import * as React from 'react';

export default class Healthz extends React.Component {
    render() {
      return <h1>Healthy</h1>;
    }
  }